import { Injectable } from "@angular/core";
import { CustomerClient, WebCustomer } from "../models";
import { AdvancedSearchOptions } from "../models";
import { Subject, Observable } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class NewCustomerSearchService
{
    private customerListItemsSubject: Subject<WebCustomer[]>;
    public customerList: Observable<WebCustomer[]>;
    public searchOptions: AdvancedSearchOptions;

    constructor(private customerClient: CustomerClient)
    {
        this.customerListItemsSubject = new Subject<WebCustomer[]>();
        this.customerList = this.customerListItemsSubject.asObservable();
    }

    public getCustomerListItemsAdvanced(searchOptions: AdvancedSearchOptions)
    {
        this.customerClient
            .getWebCustomerListItemsAdvanced(searchOptions)
            .subscribe(customers => this.customerListItemsSubject.next(customers));
    }
}
